import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

import SaleAuditList from "../../components/SaleAuditList";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    overflowY: "auto",
    boxSizing: "border-box",
  },
}));

const SaleAudits = () => {
  const classes = useStyles();

  // Embed (aba do ERP): mesmo padrão de altura do CrmTickets —
  // sem altura explícita a página renderia cortada dentro do iframe.
  const embed = sessionStorage.getItem("whaticketEmbed") === "1";

  return (
    <div
      className={classes.root}
      style={{ height: embed ? "100vh" : "calc(100vh - 48px)" }}
    >
      <Typography variant="h6" gutterBottom>
        {i18n.t("saleAudits.title")}
      </Typography>

      <SaleAuditList />
    </div>
  );
};

export default SaleAudits;
